import { CssBaseline, GlobalStyles } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './localization'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <CssBaseline />
    <HashRouter>
      <GlobalStyles
        styles={{
          body: { backgroundColor: "#efefef" }
        }}
      />

      <App />
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
